export const projectFilterOptions = (directory, orders) => {
  const options = new Map(directory.map((p) => [`id:${p.id}`, { ...p, value: `id:${p.id}` }]));
  orders.forEach((po) => {
    if (po.projectId) {
      const value = `id:${po.projectId}`;
      if (!options.has(value)) options.set(value, { value, id: po.projectId, name: po.projectName || po.projectId, status: 'Historical' });
    } else if (po.projectName) {
      const value = `name:${po.projectName}`;
      options.set(value, { value, id: '', name: po.projectName, status: 'Legacy name only' });
    }
  });
  return [...options.values()].sort((a, b) => a.name.localeCompare(b.name) || a.id.localeCompare(b.id));
};

export const matchesProjectFilter = (po, selected) => {
  if (!selected) return true;
  // Never collapse two real IDs sharing a name. Name fallback is ONLY for
  // old orders with no ID; those cannot be uniquely attributed retroactively.
  if (po.projectId) return Boolean(selected.id) && po.projectId === selected.id;
  return po.projectName === selected.name;
};